import { StyledModalText, UIButton } from "common/components";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { deactivateModal } from "domains/modal/actions";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { getModalParams } from "domains/modal/selectors";
import type { ModalParams } from "domains/modal/types";

export const ConfirmCloseEditSourceFormModal = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();

  const { onCloseModal } = useSelector(getModalParams) as ModalParams<"ConfirmCloseEditSourceForm">;

  const handleYes = () => {
    dispatch(deactivateModal());
    onCloseModal?.();
  };

  return (
    <>
      <ModalHeader title="You have unsaved changes." />
      <StyledModalText>Are you should you want to leave this page? Your changes will be erased.</StyledModalText>
      <UIButton data-test-id="confirm-deleting-custom-map-button" error fullwidth onClick={handleYes}>
        {translate("app.create.delete.confirm")}
      </UIButton>
    </>
  );
};
